import { h, Fragment } from 'preact'
import { useEffect } from 'preact/hooks'
import { usePublicProfiles } from 'lib/membershipAppStateHooks'
import EndUserDMAvatar from 'components/EndUserDMAvatar'
import { useAcceptedMembershipsForOrganization } from 'lib/membershipAppStateHooks'
import Header from 'components/Header'
import { publicProfileToDisplayName } from 'lib/publicProfiles'
import './index.sass'


export function DMChatChannelHeader({
  organization,
  onAdminStatusChange,
  myPublicProfile,
  memberUserDids,
  chatChannel,
  chatImage }) {
  const { acceptedOrganizationMemberships } =
  useAcceptedMembershipsForOrganization(organization.apikey, 'OrganizationChatPage')
  const otherMemberDids = new Set(memberUserDids)
  otherMemberDids.delete(myPublicProfile.did)


  const otherMemberDid = otherMemberDids.values().next().value


  useEffect(() => {
    if (otherMemberDids.size === 1) {
      const otherMemberDid = otherMemberDids.values().next().value
      const isOtherMemberAdmin = acceptedOrganizationMemberships.some(membership =>
        membership.memberUserDid === otherMemberDid && membership.admin)
      onAdminStatusChange(isOtherMemberAdmin)
    } else {

      onAdminStatusChange(false)
    }
  }, [acceptedOrganizationMemberships, otherMemberDid, onAdminStatusChange])

  const { publicProfiles } = usePublicProfiles(
    [...otherMemberDids],
    'OrganizationChatPage'
  )

  const isDirectChat = chatChannel.memberUserDids?.length === 2 && !chatChannel.isGroupChat
  const otherMemberProfile = publicProfiles.find(profile => myPublicProfile.did !== profile.did)

  // Generate chat name based on members
  const generateChatName = () => {
    if (isDirectChat) {

      const userChatName = publicProfileToDisplayName(otherMemberProfile)
      const isChannelNameIsDM = chatChannel.name === 'unnamed chat' || "DefaultChatName"
      return isChannelNameIsDM ? userChatName : chatChannel.name
    } else {
      if (chatChannel.name && chatChannel.name !== 'DefaultChatName') {
        return chatChannel.name
      }
      const otherMemberDids = new Set(memberUserDids)
      otherMemberDids.delete(myPublicProfile.did)

      const otherMembers = publicProfiles
        .filter(profile => otherMemberDids.has(profile.did))

      // Get the display names of the first 3 members
      const firstThreeNames = otherMembers
        .slice(0, 3)
        .map(profile => publicProfileToDisplayName(profile))

      const additionalCount = otherMembers.length - 3

      if (additionalCount <= 0) {
        return firstThreeNames.join(', ')
      } else {
        return `${firstThreeNames.join(', ')}, ${additionalCount} others`
      }
    }
  }

  const chatName = generateChatName()


  return <Fragment>
    <EndUserDMAvatar {...{ size: 'sm', chatImage, publicProfiles }}  />

    <Header size="lg">
      <p style={{padding:'0.5rem', fontWeight:'bold'}}>{chatName}</p>
    </Header>
  </Fragment>
}
